export default __webpack_public_path__ + "static/media/logo138x75white.422f8d33.png";